import { Autocomplete, Divider, Grid, TextField, Tooltip, Typography, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import style from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import workflowStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import GlobalButton from '../../../../../utility/globalButton/button';
import { functionParameterData, functionResponseData } from '../../../../../../models/axiosModel';
import Required from '../../../../../utility/required';
// import { createWebhookPayload, functionResponse } from './customAPIConfigPopup'; 
// import { createWebhookPayload, functionResponse } from "../../"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GlobalTooltip from '../../../../../utility/tooltip/globalTooltip';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';

interface EditResponseVarPathPopupProps {
    selectedResPayload: any,
    setSelectedResPayload: React.Dispatch<React.SetStateAction<any | null>>,
    setFlagEditResVarPathPopup: React.Dispatch<React.SetStateAction<boolean>>,
    setPayload: React.Dispatch<React.SetStateAction<any>>,
    fieldKeyName: string,
}

const EditResponseVarPathPopup: React.FC<EditResponseVarPathPopupProps> = (props) => {

    const { selectedResPayload, setSelectedResPayload, setFlagEditResVarPathPopup, setPayload, fieldKeyName } = props; 

    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;

    const getPath = () => {
        if(fieldKeyName == "action_await_webhook_identifier_field_data"){
            return selectedResPayload?.identifier_field_path || "";
        } 
        return selectedResPayload?.field_value_path || "";
    }

    const getPathSegments = (pathStr: string) => {
        const regex = /(\[[^\]]+\])/g;
        let result: (string | { indexKey: string; original: string })[] = [];
        let lastIndex = 0;
        let indexCounter = 0;

        let match;
        while ((match = regex.exec(pathStr)) !== null) {
            const fullMatch = match[0];
            const inside = fullMatch.slice(1, -1).trim();

            const staticBefore = pathStr.slice(lastIndex, match.index);
            if (staticBefore) result.push(staticBefore);

            const unquoted = inside.replace(/^['"]|['"]$/g, '');

            if (/^\d+$/.test(unquoted) || unquoted === "INDEX") {
                result.push({ indexKey: `index_${indexCounter++}`, original: fullMatch });
            } else {
                result.push(fullMatch);
            }

            lastIndex = match.index + fullMatch.length;
        }

        const remaining = pathStr.slice(lastIndex);
        if (remaining) result.push(remaining);

        return result;
    };

    const reconstructPath = (originalPath: string, resVar: any): string => {
        const segments = getPathSegments(originalPath);

        return segments.map(segment => {
            if (typeof segment === "string") return segment;

            const val = resVar[segment.indexKey] ?? segment.original.slice(1, -1).replace(/^['"]|['"]$/g, '');

            if (val === "INDEX") {
                return `[INDEX]`;
            } else {
                return `["${val}"]`;
            }
        }).join('');
    };

    const handleUpdate = () => {
        const originalPath =  getPath() || "";
        const updatedPath = reconstructPath(originalPath, selectedResPayload);

        if(fieldKeyName == "action_await_webhook_identifier_field_data"){
            setPayload((prevState: any) => ({
                ...prevState,
                action_await_webhook_identifier_field_data: prevState?.action_await_webhook_identifier_field_data?.map((field: any) => {
                    if(field?.action_await_webhook_identifier_field_id == selectedResPayload?.action_await_webhook_identifier_field_id) {
                        return {
                            ...field, 
                            identifier_field_path: updatedPath,
                        }
                    } 
                    return field;
                })
            }))
        } else {
            setPayload((prevState: any) => ({
                ...prevState,
                action_await_webhook_save_variable: prevState?.action_await_webhook_save_variable?.map((field: any) => {
                    if(field?.action_await_webhook_save_variable_id == selectedResPayload?.action_await_webhook_save_variable_id) {
                        return {
                            ...field, 
                            field_value_path: updatedPath,
                        }
                    } 
                    return field;
                })
            }))
        }

        setFlagEditResVarPathPopup(false);
    }

    useEffect(() => {
        if (!selectedResPayload) return;

        const segments = getPathSegments(getPath() || "");
        const newSelected: any = { ...selectedResPayload };

        segments.forEach(segment => {
            if (typeof segment === "object") {
                const val = segment.original.slice(1, -1).replace(/^['"]|['"]$/g, '');
                newSelected[segment.indexKey] = val;
            }
        });

        setSelectedResPayload(newSelected);
    }, []);
    
    return (
        <>
            <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                <Grid item className={`${globalStyles.textCenter}`}>
                    <Typography className={style.popupTitleTypography}> {`Edit Path for  ${selectedResPayload?.key || ""}`}</Typography>
                </Grid>

                <Divider className={style.popupTitleDivider} />

                <Grid item>
                    <Grid container className={style.popupBodyGridContainer} gap={1}>
                        <Grid item xs={12}>
                            <Grid container gap={"12px"}>
                                <Grid item xs={12}>
                                    <Grid container gap={1}>
                                        <Grid item>
                                            <Typography className={style.popupFieldTypography}>Path <Required />
                                            </Typography>
                                        </Grid>
                                        <Grid item className={globalStyles.clickable}>
                                            <GlobalTooltip
                                                title="If there is an array in the path, you can choose which item (index) to use. If you don't select any index, it will show values from all items in that array, separated by commas."
                                                placement='bottom'
                                                arrow={true}
                                                children={<InfoOutlinedIcon className={workflowStyles.iButton} />}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={workflowStyles.responseVariablePathGrid}>
                                    {getPathSegments(getPath() || "").map((segment, i) => {
                                        if (typeof segment === "string") {
                                            return (
                                                <Typography className={workflowStyles.stringSegmentTypography} component="span" key={`text-${i}`}>
                                                    {segment}
                                                </Typography>
                                            );
                                        } else {
                                            const selectedValue = (selectedResPayload as any)[segment.indexKey] ?? segment.original.slice(1, -1).replace(/^['"]|['"]$/g, '');

                                            return (
                                                <React.Fragment key={`autocomplete-${segment.indexKey}`}>
                                                    <Typography className={workflowStyles.autocompleteBracket} component="span">[</Typography>
                                                    <Autocomplete
                                                        disableClearable
                                                        options={["INDEX", ...Array.from({ length: 101 }, (_, i) => i.toString())]}
                                                        value={selectedValue}
                                                        onChange={(_, newVal) => {
                                                            setSelectedResPayload((prev: any) =>
                                                                prev ? { ...prev, [segment.indexKey]: newVal || "INDEX" } : prev
                                                            );
                                                        }} 
                                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                        renderInput={(params) => (<TextField {...params} variant="outlined" size="small" />)}
                                                        className={`${style.contactFilterDropdownsInPopup} ${workflowStyles.editResVarIndexAutoComplete}`}
                                                    />
                                                    <Typography className={workflowStyles.autocompleteBracket} component="span">]</Typography>
                                                </React.Fragment>
                                            );
                                        }
                                    })}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item>
                    <Grid container className={`${globalStyles.justifyCenter} ${globalStyles.alignItemCenter} ${workflowStyles.editResponseVarPathPopupBtnContainer}`} gap={"12px"} sx={{ padding: "20px 0" }}>
                        <Grid item>
                            <GlobalButton
                                buttonText="Cancel"
                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                className='borderedButtonStyle' 
                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    setFlagEditResVarPathPopup(false);
                                    setSelectedResPayload(null);
                                }}
                            />
                        </Grid>

                        <Grid item>
                            <GlobalButton
                                buttonText={"Update"}
                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                className='primaryButtonStyle' 
                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    handleUpdate();
                                }}
                            >
                            </GlobalButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default EditResponseVarPathPopup
